// Defines the finn-topbar element that provides a fallback for if the DSD is re-added to the page
// (usually by React meta frameworks that own the whole page)

class FinnTopbar extends HTMLElement {
    connectedCallback() {
        if (!this.shadowRoot) {
            const template = this.querySelector("template[shadowrootmode]");
            const shadow = this.attachShadow({ mode: "open" });
            shadow?.appendChild(template.content.cloneNode(true));
            template.remove();
        }

        // mirror Warp's theme from <html data-w-theme> onto the host so shadow styles can use :host([theme])
        this.syncTheme();
        this.themeObserver = new MutationObserver(() => this.syncTheme());
        this.themeObserver.observe(document.documentElement, { attributeFilter: ['data-w-theme'] });
    }

    disconnectedCallback() {
        this.themeObserver?.disconnect();
    }

    syncTheme() {
        const theme = document.documentElement.getAttribute('data-w-theme');
        if (theme) this.setAttribute('theme', theme);
        else this.removeAttribute('theme');
    }
}
if (!customElements.get('finn-topbar')) {
    customElements.define('finn-topbar', FinnTopbar);
}